function useEmoji(boolean){
        if(boolean){
            return '⭕️'
        } else {
            return '❌'
        }
}

export default useEmoji